import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const OjieWithRedFlagIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 732 732" {...props}>
      <path
        d="M138 39H153L160 43L165 51L168 64L169 79L185 71L195 65L211 59L227 56H247L262 60L281 69L300 75L316 78H339L355 74L364 71L365 77V96L363 113L359 128L344 155L342 160L358 194L366 209H377L393 200L409 193L422 189L439 186H461L476 189L489 194L500 200L517 212L527 221L535 228L548 242L561 259L574 277L582 287L588 292L583 297L570 306H568L583 331L595 354L603 375L609 400L611 414L612 429V449L610 475L606 499L600 522L592 543L584 559L578 570L570 582L560 595L548 609L536 621L525 630L513 640L495 652L474 664L452 674L422 684L400 689L379 692L366 693H339L313 690L289 685L263 677L239 667L222 658L207 648L193 637L177 622L170 615L163 607L151 592L142 579L132 563L123 552L115 537L111 525L110 519V504L111 494V465L110 443V405L112 386L116 370L125 348L133 332L141 317L153 299L154 295L146 238L135 138L128 73L124 48L125 44L134 40L138 39ZM235 232L221 236L204 245L192 254L193 258L207 248L224 239L239 233L235 232Z"
        fill="#F99D2D"
      />
      <path
        d="M138 39H153L160 43L165 51L168 64L169 79L185 71L195 65L211 59L227 56H247L262 60L281 69L300 75L316 78H339L355 74L364 71L365 77V96L363 113L359 128L344 155L342 160L358 194L366 209H377L393 200L409 193L422 189L439 186H461L476 189L489 194L500 200L517 212L527 221L535 228L548 242L561 259L574 277L582 287L588 292L583 297L570 306L548 316L531 321L509 324L522 329L533 335L546 347L554 358L561 372L564 385V407L561 421L557 431L549 443L540 453L529 461L517 467L504 471L499 472H479L464 468L448 460L438 452L428 441L419 424L416 415L415 408V383L420 367L428 353L437 343L446 335L463 326L475 323L482 322L483 321L469 316L452 307L438 297L426 286L418 279L409 269L398 256L390 245V243L380 247L365 253L354 255H333L319 251L292 239L278 234L260 231H245L227 235L215 240L204 246L193 254V265L197 302L199 315L201 343L203 349L212 340L224 333L230 331L237 330H251L265 334L276 341L284 349L290 359L293 366L294 371V391L291 401L285 411L276 421L268 426L269 431L277 463L281 479V488L277 496L269 501H255L259 509V526L260 531V540L257 550L251 558L242 566L227 574L211 580L201 583L188 585H162L150 580L140 571L136 567V565L132 563L123 552L115 537L111 525L110 519V504L111 494V465L110 443V405L112 386L116 370L125 348L133 332L141 317L153 299L154 295L146 238L135 138L128 73L124 48L125 44L134 40L138 39Z"
        fill="#030302"
      />
      <path
        d="M439 186H461L476 189L489 194L500 200L517 212L527 221L535 228L548 242L561 259L574 277L582 287L588 292L583 297L570 306L548 316L531 321L509 324L522 329L533 335L546 347L554 358L561 372L564 385V407L561 421L557 431L549 443L540 453L529 461L517 467L504 471L499 472H479L464 468L448 460L438 452L428 441L419 424L416 415L415 408V383L420 367L428 353L437 343L446 335L463 326L475 323L482 322L483 321L469 316L452 307L438 297L426 286L418 279L409 269L398 256L390 245V243H388L379 232L369 217L366 212V210L377 209L393 200L409 193L422 189L439 186Z"
        fill="#97C13C"
      />
      <path
        d="M228 68H249L268 73L293 83L309 88L324 91H352V102L349 119L343 138L337 148L333 153L330 155L331 161L350 200L363 225L370 236L369 239L360 243L353 244H342L330 242L315 236L301 230L287 225L276 222L270 221H249L227 225L207 232L190 241L180 249L172 255L159 259H156L152 216L150 199L147 167L145 150L142 118L141 113V97L156 93L182 84L201 75L217 70L228 68Z"
        fill="#FD5900"
      />
      <path
        d="M482 322H496L509 324L522 329L533 335L546 347L554 358L561 372L564 385V407L561 421L557 431L549 443L540 453L529 461L517 467L504 471L499 472H479L464 468L448 460L438 452L428 441L419 424L416 415L415 408V383L420 367L428 353L437 343L446 335L463 326L475 323L482 322Z"
        fill="#FDFDFC"
      />
      <path
        d="M161 443H179L206 448L221 451L223 458L225 472L226 476L207 483L194 487L170 489L171 493L175 496L183 498H197L212 493L226 487L230 485L238 492L237 496L227 505L211 515L198 520L192 521H177L173 519L169 520L170 524L175 528L178 529H194L206 526L222 520L234 513L241 507L245 508L248 513V521L242 530L235 537L222 545L210 550L203 552L187 553V558L191 560H202L213 557L228 551L240 544L244 542L242 547L235 556L225 563L211 569L204 571L189 573H170L158 571L147 565L140 557L132 543L125 524L123 512V498L125 489L133 472L144 454L151 447L157 444L161 443Z"
        fill="#FCFCFC"
      />
      <path
        d="M473 334H487L501 338L512 345L520 353L526 363L529 370L530 375V395L527 405L521 415L512 425L500 432L492 435L485 436H471L459 432L447 425L440 418L433 407L429 394V375L432 365L439 353L448 344L460 337L466 335L473 334Z"
        fill="#010101"
      />
      <path
        d="M155 297H156L160 322L162 336L170 385L172 397L177 429V434H155L146 438L137 445L127 459L119 476L114 491L112 498L111 494V465L110 443V405L112 386L116 370L125 348L133 332L141 317L153 299L155 297Z"
        fill="#F7962B"
      />
      <path
        d="M366 210H376L374 215L379 220L397 234L414 246L433 258L451 268L468 276L487 281L501 284L544 289L587 291V294L572 305L548 316L531 321L519 323H496L480 320L467 315L452 307L438 297L426 286L418 279L409 269L398 256L390 245V243H388L379 232L369 217L366 212V210Z"
        fill="#809F3D"
      />
      <path
        d="M182 261H183L186 290L190 324L196 379L198 395L202 431V436L186 434L184 428L179 404L175 379L171 355L166 317L163 296L160 277V268L178 263L182 261Z"
        fill="#D6D6D6"
      />
      <path
        d="M220 322H240L251 324L264 329L275 335L288 347L297 359L304 375L306 385V411L300 429L292 442L283 452L275 458L270 440L268 431L267 426L278 418L285 410L292 396L293 391V371L290 361L285 352L276 342L265 335L251 331H237L227 333L215 339L205 348L202 350L200 343V329L208 325L220 322Z"
        fill="#FBFAF9"
      />
      <path
        d="M239 431H251L257 435L262 443L265 452L268 468L271 475L270 483L265 488L263 489H253L244 486L239 480L236 473L235 468V450L238 440L232 439L228 444L212 441V438L231 435L239 431Z"
        fill="#F9F9F9"
      />
      <path
        d="M345 529H360L369 532L381 539L390 548L394 555L395 559V567L392 573L391 574H385L380 569L377 565L373 554L367 547L360 543L356 542H345L335 548H329L326 546V539L331 534L340 530L345 529Z"
        fill="#040300"
      />
      <path
        d="M164 363H166L169 379L171 394L175 415L177 429V434H166L159 419L157 408V383L162 367L164 363Z"
        fill="#F9F8F7"
      />
      <path
        d="M133 50H149L156 53L159 57L161 66L162 82L148 86L137 87L134 66L133 50Z"
        fill="#D4D4D4"
      />
      <path
        d="M245 230H260L278 233L294 239L313 247V248H292L281 245L271 241L255 235L245 231V230Z"
        fill="#7D993B"
      />
      <path
        d="M233 310H239L242 313V320L241 322L244 323L227 322L228 315L233 310Z"
        fill="#FAB77D"
      />
      <path
        d="M366 210H376L374 215L382 231L386 237L385 239L378 231L366 212V210Z"
        fill="#E57A24"
      />
      <path
        d="M212 340L215 343L214 350L211 353H205L201 352L202 348H204L212 340Z"
        fill="#4F4F4F"
      />
      <path
        d="M158 357L163 358L164 362L166 363H164L162 370L156 368L155 361L158 357Z"
        fill="#F8A552"
      />
      <path
        d="M278 272H281L282 278L279 282L274 281L275 275L278 272Z"
        fill="#FAC8A1"
      />
      <path
        d="M199 295L203 297L202 303L201 305H197V296L199 295Z"
        fill="#F9B379"
      />
      <path d="M209 419L218 425L216 427L209 428V419Z" fill="#E7E7E7" />
    </SvgIcon>
  );
};

export default OjieWithRedFlagIcon;
